import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { FormBuilder } from 'shared-components/forms/form';
import whiteBackground from '../wrapper-components/white-background';
import { DateTimeMain } from '../elements-date-time/date-time-main';
import { fetchBooking, updateBooking } from '../app-main/actions/booking';
import removeKeys from '../app-main/utilities/removeKeys';
import { get, isEmpty } from 'lodash';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';
import StickyNavigation from 'shared-components/partials-navigation/StickyNavigation';

class AttendeeAddDetailsPageBody extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      schedule: []
    };

    this.redirectToPreview = this.redirectToPreview.bind(this);
    this.redirectToEmailSend = this.redirectToEmailSend.bind(this);
    this.redirectToInbox = this.redirectToInbox.bind(this);
    this.getSchedule = this.getSchedule.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.cancelAction = this.cancelAction.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handlePreview = this.handlePreview.bind(this);
    this.handleSkip = this.handleSkip.bind(this);
    this.inviteAnaltyics = this.inviteAnaltyics.bind(this);
    this.formRef = React.createRef();
    this.onParentFormSubmit = this.onParentFormSubmit.bind(this);
  }

  componentDidMount () {
    const bookingId = get(this.props, 'routeParams.bookingId');
    const { dispatch, accessToken } = this.props;
    dispatch(fetchBooking(bookingId, accessToken));
  }

  getSchedule (schedule) {
    return this.setState({ schedule });
  }

  onParentFormSubmit (e) {
    this.formRef.current.submitForm(e);
  }

  onSubmit (elements, submitCb, inputRefs) {
    const schedule = get(inputRefs, 'schedule.getLatestValue', () => {})();
    const title = get(inputRefs, 'title.getValue', () => {})();
    let personalNote = get(inputRefs, 'personalNote.getValue', () => {})();

    if (!personalNote.length) {
      personalNote = inputRefs.personalNote.props.defaultVal;
    }

    const newState = removeKeys({
      guest_schedule: schedule,
      guest_title: title,
      guest_notes: personalNote
    }, { removeUndefinedValue: true });

    const bookingId = get(this.props, 'booking.booking._id');

    const {
      dispatch,
      accessToken,
      pageType,
      submitRedirect
    } = this.props;

    dispatch(updateBooking(bookingId, newState, accessToken, response => {
      if (200 === response.statusCode) {
        analyticsIntegrations.addDetailsInvite(get(this.props, 'booking.booking'), newState, pageType);

        submitRedirect();
      }
    }, true));
  }

  redirectToPreview () {
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    const publicBookingId = get(this.props, 'booking.booking.pid');
    this.props.dispatch(push(`${urlPrefix ? `/${urlPrefix}` : ''}/invite/${publicBookingId}`));
  }

  redirectToEmailSend () {
    const publicBookingId = get(this.props, 'booking.booking.pid');
    this.props.dispatch(push(`/invite/send/${publicBookingId}`));
  }

  redirectToInbox () {
    const bookingId = get(this.props, 'booking.booking._id');
    this.props.dispatch(push(`/inbox/${bookingId}`));
  }

  cancelAction () {
    this.props.toggleModal('');
    this.props.cancelRedirect();
  }

  handleCancel (e) {
    e.preventDefault();
    this.props.toggleModal('cancelModal');
  }

  handleSkip (e) {
    e.preventDefault();
    this.redirectToInbox();
  }

  inviteAnaltyics (payload, action) {
    analyticsIntegrations.sendInvite(
      get(this.props, 'booking.booking'),
      payload,
      this.props.pageType,
      action
    );
  }

  handlePreview (e) {
    e.preventDefault();
    const urlPrefix = SharedIntlProviderHOC.getUrlPrefix();
    const publicBookingId = get(this.props, 'booking.booking.pid');
    this.inviteAnaltyics(null, 'preview_invite');
    window.open(`${urlPrefix ? `/${urlPrefix}` : ''}/invite/${publicBookingId}`, '_blank');
  }

  textResponseLabel () {
    return (
      <div>
        <label htmlFor="eventTitle" className="h6 no-top-margin no-top-padding control-label text-left">
          <FormattedMessage
            id='invite.attendee_add_details_page_body.booking_title'
            defaultMessage='Booking title'
          />
        </label>
      </div>
    );
  }

  personalMessageLabel () {
    return (
      <div>
        <label htmlFor="eventTitle" className="h6 no-top-margin no-top-padding control-label text-left">
          <FormattedMessage
            id='invite.attendee_add_details_page_body.personal_note'
            defaultMessage='Personal note'
          />
        </label>
      </div>
    );
  }

  render () {
    this.eventDetails = {};
    const booking = get(this.props, 'booking.booking', {});
    const bookingTimes = get(booking, 'schedule', {});
    const listing = get(booking, 'listing', {});
    const firstImg = get(listing, 'images[0].urlLarge');
    const afterMidnight = get(booking, 'after_midnight');

    const formInputs = [
      {
        inputFieldName: 'default_input',
        elementID: 'eventTitle',
        ref: ref => { this.eventDetails.title = ref; },
        customLabel: this.textResponseLabel(),
        optional: false,
        colSize: '',
        defaultVal: get(booking, 'public_fields.guest_title') || this.props.intl.formatMessage({ id: 'invite.attendee_add_details_page_body.event', defaultMessage: '{name}\'s Event' }, { name: get(booking, 'guest.name.first') }),
        errorMessage: this.props.intl.formatMessage({ id: 'invite.attendee_add_details_page_body.enter_title', defaultMessage: 'Please enter a title.' })
      },
      {
        custom: () => {
          return (
            <div className="margin-xl-top">
              <div>
                <p className="h6 no-bottom-margin no-top-margin">
                  <FormattedMessage id='invite.attendee_add_details_page_body.edit_times' defaultMessage='Edit times shown to guests' />
                </p>
                <p className="text-gray-dark margin-md-bottom">
                  <FormattedMessage id='invite.attendee_add_details_page_body.changing_times' defaultMessage='Changing the times on your invite will not impact your booking – only what your guests will see.' />
                </p>
              </div>

              <DateTimeMain
                multiday={false}
                ref={ref => { this.eventDetails.schedule = ref; }}
                actionFn={this.getSchedule}
                optional={false}
                scheduleFromProps={
                  get(booking, 'public_fields.guest_schedule')
                  || get(booking, 'schedule')
                  || []
                }
                spaceId={get(booking, 'space_id')}
                excludeBookingIds={[get(booking, '_id')]}
                preventEditDates
                showDateLabel={false}
                country={get(listing, 'country', '')}
                useBootstrapGrid={false}
                bookingTimes={bookingTimes}
                noAvailabilityGet={true}
                afterMidnight={afterMidnight}
              />
            </div>
          );
        }
      },
      {
        inputFieldName: 'default_textarea',
        elementID: 'eventPersonalNote',
        ref: ref => { this.eventDetails.personalNote = ref; },
        customLabel: this.personalMessageLabel(),
        optional: true,
        colSize: 'margin-xl-top',
        defaultVal: get(booking, 'public_fields.guest_notes') || this.props.intl.formatMessage({ id: 'invite.attendee_add_details_page_body.check_space', defaultMessage: 'Check out the space I booked on Peerspace. Let me know if you can make it!' })
      }
    ];

    return (
      <div className="AttendeeAddDetailsPageBody ps-container-md-margin">
        <div className="ps-row">
          <div className="col-xs-12 col-md-6 imageHalf">
            <div className="listing-img" style={{ backgroundImage: `url(${firstImg})` }}>
              <div className="image-text-content">
                <p className="step-counter mobile">Step 1 of 2</p>
                <h1 className="invite-title"><FormattedMessage id='invite.attendee_add_details_page_body.invite_title' defaultMessage="You're booked! Let's get ready for your event." /></h1>
                <div className="invite-icon">
                  <p className="no-bottom-margin"><FormattedMessage id='invite.attendee_add_details_page_body.check_your_email' defaultMessage="Check your email for full booking details" /></p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 invite-form">
            <div className="invite-form-container position-relative">
              <p className="step-counter"><FormattedMessage id='invite.attendee_add_details_page_body.step_one' defaultMessage="Step 1 of 2" /></p>
              <h3><FormattedMessage id='invite.attendee_add_details_page_body.let_your_guests_know' defaultMessage="Let your guests know" /></h3>
              <p className="text-large text-gray-900 no-bottom-margin send-an-invite-msg">
                <FormattedMessage id='invite.attendee_add_details_page_body.send_an_invite' defaultMessage='Send an invite to those attending, allowing them to RSVP and view important details about the event such as address, wifi info and more.' />
              </p>

              {!isEmpty(get(this.props, 'booking.booking'))
                && <FormBuilder
                  ref={this.formRef}
                  formname="addDetails"
                  formStyle="standard"
                  formInputs={formInputs}
                  submitAction={this.onSubmit}
                  submitCallback={() => { }}
                  isButtonDisabled={false}
                  containerClass='form-btn-container container-fluid'
                  rowClass="row"
                  buttonClass="hidden"
                  errorText=""
                  inputRefs={this.eventDetails}
                  useBootstrapGrid={false}
                />
              }
              <StickyNavigation>
                <div className="padding-xl-bottom padding-xl-top sticky-footer bg-white flex space-between">
                  {this.props.showSkip
                    && <button className="btn btn-link underline no-gutter-left" onClick={this.handleSkip}>
                      <FormattedMessage id='invite.attendee_add_details_page_body.do_this_later' defaultMessage="I'll do this later" />
                    </button>
                  }
                  <button className="btn btn-primary" onClick={this.onParentFormSubmit}>
                    <FormattedMessage id='invite.attendee_add_details_page_body.save_and_preview' defaultMessage="Save and preview" />
                  </button>
                </div>
              </StickyNavigation>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AttendeeAddDetailsPageBody.defaultProps = {
  pageType: 'add_details'
};

AttendeeAddDetailsPageBody.propTypes = {
  dispatch: PropTypes.func,
  toggleModal: PropTypes.func,
  whichModal: PropTypes.func,
  accessToken: PropTypes.string,
  pageType: PropTypes.string,
  submitRedirect: PropTypes.func,
  cancelRedirect: PropTypes.func,
  showSkip: PropTypes.bool,
  submitButtonText: PropTypes.string,
  callToActionText: PropTypes.string,
  intl: intlShape
};

function mapStateToProps (state) {
  const { auth, booking } = state;
  const { accessToken } = auth;

  return {
    accessToken,
    booking
  };
}

export default injectIntl(connect(mapStateToProps)(whiteBackground(AttendeeAddDetailsPageBody)));
